import { Grid } from '@mui/material'
import { GridDirection } from '@mui/material/Grid'
import { SvgIconProps } from '@mui/material/SvgIcon'
import * as React from 'react'

interface ITitleBarProps {
  title: string | JSX.Element
  titleComponent?: JSX.Element
  titleButton?: JSX.Element
  isTitleComponentPushedRight?: boolean
  icon?: React.ComponentType<SvgIconProps>
  formGridDirection?: GridDirection
  formGridAlignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline'
  headerStyle?: React.CSSProperties
}

const TitleBar: React.FC<ITitleBarProps> = ({
  icon,
  isTitleComponentPushedRight = false,
  title,
  titleComponent,
  titleButton,
  headerStyle = {},
}) => {
  const componentStyles = () => {
    if (isTitleComponentPushedRight) {
      return {
        marginLeft: 'auto',
      } as React.CSSProperties
    } else {
      return undefined
    }
  }

  const Icon = icon

  const cardHeader = (
    <Grid
      container
      item
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{
        height: 60,
        marginBottom: 1,
        marginLeft: 1,
        ...headerStyle,
      }}
      xs={12}
      style={{ marginLeft: 0 }} // this is needed because material UI grid spacing applies -8px margin.
    >
      <Grid item>{Icon && <Icon style={{ fontSize: '32px' }} color="secondary" />}</Grid>
      <Grid item sx={{ fontSize: '20px', paddingTop: '4px' }}>
        {title}&nbsp;{titleButton}
      </Grid>
      {titleComponent && (
        <Grid item style={componentStyles()}>
          {titleComponent}
        </Grid>
      )}
    </Grid>
  )

  return (
    <Grid container direction="row" spacing={1}>
      {cardHeader}
    </Grid>
  )
}

export default TitleBar
